export const CHANNEL_CLIENT = { name: "Client", value: "client" };
export const CHANNEL_TEAMSAPP = { name: "Teams App", value: "teams-app" };
export const CHANNEL_EMBEDDED = { name: "Embedded", value: "embedded" };
export const CHANNEL_BROWSERPLUGIN = {
  name: "Browser Plugin",
  value: "browser-plugin",
};
export const DASHBOARD_ACCESS_ICON = { name: "From Icon", value: "icon" };
export const DASHBOARD_ACCESS_INSIDE_APP = {
  name: "From inside the app",
  value: "inside-app",
};

export const DASHBOARD_TYPE_OPTIONS = [
  { value: "copilot_go_v1", label: "CopilotGo V1" },
  { value: "copilot_go_v2", label: "CopilotGo V2" },
  { value: "bloom", label: "Bloom" },
  { value: "aiskilling", label: "AI Skilling" },
  { value: "snam_cyber_route", label: "Snam Cyber Route" },
  { value: "knowledge-hub", label: "Knowledge Hub" },
  { value: "easypop", label: "EasyPop" },
  { value: "fincantieri", label: "Fincantieri Cyber Dashboard" },
  { value: "cdp", label: "CDP Cyber Dashboard" },
  { value: "cyber_olympics", label: "Cyber Olympics" },
  { value: "wecare", label: "WeCare" },
  { value: "ai_collection", label: "AI Collection" },
  { value: "alfasigma-aibility", label: "AI.bility (Alfasigma)" },
];

export const DASHBOARD_TYPE_LOOKUP = Object.fromEntries(
  DASHBOARD_TYPE_OPTIONS.map(({ value, label }) => [value, label])
);
